import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnfavourite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "m12 3.592-1.887 3.825a3.124 3.124 0 0 1-2.35 1.707l-4.225.617 3.056 2.974a3.123 3.123 0 0 1 .899 2.765l-.72 4.202 3.775-1.985a3.124 3.124 0 0 1 2.903 0l3.778 1.986-.722-4.205a3.124 3.124 0 0 1 .9-2.762l3.053-2.974-4.225-.619a3.125 3.125 0 0 1-2.346-1.706L12 3.592zm-.807-2.362a1.53 1.53 0 0 1 2.178.621l2.31 4.68a1.122 1.122 0 0 0 .844.614l5.164.755a1.533 1.533 0 0 1 1.267 1.88 1.53 1.53 0 0 1-.418.73l-3.736 3.638a1.123 1.123 0 0 0-.323.993m0 0 .88 5.135.001.004a1.53 1.53 0 0 1-2.223 1.614l-.003-.001-4.613-2.426a1.123 1.123 0 0 0-1.043 0l-4.614 2.427h-.002a1.53 1.53 0 0 1-2.221-1.614v-.003l.88-5.135a1.122 1.122 0 0 0-.323-.993l-3.733-3.635-.002-.002A1.53 1.53 0 0 1 2.311 7.9l5.164-.755a1.122 1.122 0 0 0 .844-.613l2.31-4.68a1.53 1.53 0 0 1 .564-.62",
		fill: "currentColor"
	})
});
export default SvgUnfavourite;
